import { Col } from "@omni/components/components/General/Grid/col.component";
import { SearchBox } from "@omni/components/components/Search/SearchBar/components/SearchBox/searchBox";
import { useGranite } from "@omni/components/redux/modules/value/translations/translations.provider";
import { cn } from "@omni/utils/styles";

type Props = {
    className?: string;
};

export const SearchBoxComponent = ({ className }: Props) => {
    const { t } = useGranite();

    return (
        <div className={cn("tw:flex tw:items-center", className)}>
            <SearchBox.CloseButton
                className={cn(
                    "tw:bg-white tw:text-primary tw:border-none tw:min-h-10 tw:w-10 tw:mr-4 tw:transition-colors tw:flex tw:items-center tw:justify-center tw:rounded-sm",
                    "tw:lg:hidden",
                    "tw:hover:bg-grey",
                    "tw:active:bg-grey tw:active:border tw:active:border-primary",
                    "tw:focus:bg-grey tw:focus:border tw:focus:border-primary"
                )}
            />
            <SearchBox.Form
                className={cn(
                    "tw:h-10 tw:bg-primary tw:layer-modal/[1] tw:rounded-sm tw:border tw:border-primary tw:relative tw:flex tw:flex-wrap tw:mx-0 tw:overflow-hidden tw:grow"
                )}
            >
                <Col
                    xs={9}
                    sm={10}
                    md={11}
                    lg={10}
                    className={cn(
                        "tw:min-w-0 tw:transition-shadow tw:bg-grey tw:ring-inset tw:ring-primary/30 tw:flex tw:p-0",
                        "tw:group-focus-within/autocomplete:ring-3!"
                    )}
                >
                    <SearchBox.Form.OpenButton
                        className={cn(
                            "tw:border-none tw:hidden tw:pl-3",
                            "tw:lg:block"
                        )}
                    />
                    <SearchBox.Form.Input
                        className={cn(
                            "tw:grow tw:border-none tw:pl-4 tw:lg:pl-2  tw:outline-none! tw:rounded-none tw:min-w-0",
                            "tw:lg:pl-2"
                        )}
                    />
                    <SearchBox.Form.ResetButton
                        color={"transparent"}
                        className={cn(
                            "tw:border-none tw:px-4 tw:capitalize tw:text-grey-input tw:bg-transparent",
                            "tw:hover:underline tw:hover:text-grey-input tw:hover:bg-transparent!",
                            "tw:focus:underline tw:focus:text-grey-input tw:focus:bg-transparent! tw:focus:ring-0"
                        )}
                    >
                        <span className={cn("tw:hidden tw:lg:block")}>
                            {t("searchBox.input.button.reset")}
                        </span>
                        <i
                            className={cn(
                                "las la-lg la-times",
                                "tw:block tw:lg:hidden"
                            )}
                        />
                    </SearchBox.Form.ResetButton>
                </Col>
                <Col
                    xs={3}
                    sm={2}
                    md={1}
                    lg={2}
                    className={cn("tw:p-0")}
                >
                    <SearchBox.Form.SubmitButton
                        color={"primary"}
                        className={cn(
                            "tw:h-full tw:w-full tw:text-lg! tw:leading-4!"
                        )}
                    >
                        <span
                            id={"submit-search-button"}
                            className={cn("tw:hidden tw:lg:block")}
                        >
                            {t("searchBox.input.button.submit")}
                        </span>
                        <i
                            className={cn(
                                "las la-lg la-search",
                                "tw:block tw:lg:hidden"
                            )}
                        />
                    </SearchBox.Form.SubmitButton>
                </Col>
            </SearchBox.Form>
        </div>
    );
};
